  <div class="iv-tab-content">
    <span
      *ngIf="!isEditTitle; else editField"
      (dblclick)="toggleEditTitle()"
      class="iv-tab-content__name"
      [tuiHint]="tab.name"
    >
      {{tab.name}}
    </span>

    <ng-template #editField>
      <input
        #editInput
        [(ngModel)]="tab.name"
        (keyup.enter)="toggleEditTitle()"
        (keyup.escape)="restoreTitle()"
        (focusout)="toggleEditTitle()"
        type="text"
        class="iv-tab-content__name tab-input"
      >
    </ng-template>

    <span class="iv-tab-content__description" [tuiHint]="tab.description">
      {{tab.description}}
    </span>
  </div>

  <div class="iv-tab__icons">
    <span (click)="closeTab(index)" *ngIf="closeable" class="material-icons close-button">
      &#xE14C;
    </span>

    <button
      (click)="toggleEditTitle()"
      *ngIf="!isEditTitle; else saveTitle"
      class="edit-button"
      [tuiHint]="'Edit tab title'"
      >
      <tui-svg src="tuiIconEdit"></tui-svg>
    </button>

    <ng-template #saveTitle>
      <button
        (click)="toggleEditTitle()"
        class="edit-button"
        [tuiHint]="'Save tab title'"
      >
        <span class="material-icons close-button">save_as</span>
      </button>
    </ng-template>

  </div>
